import { useCallback } from 'react';

import { useProfileManager } from '@/shared/hooks/useProfileManager';

import { StreamHandler } from '../../feature-player/hooks/config/use-stream-handler';
import { getTrailerPlayerConfig } from '../utils/get-trailer-player-config';

export const useTrailerPlayerConfigHandler: () => StreamHandler = () => {
    const profileManager = useProfileManager();

    return useCallback(
        (baseInfo) => {
            if (baseInfo?.__typename === 'OttTrailer') {
                return getTrailerPlayerConfig(baseInfo, { profileManager });
            }
            return null;
        },
        [profileManager]
    );
};
